export default "__VITE_ASSET__50221e9b__"